import React from "react";

const NoData = () => {
  return <div></div>;
};

export default NoData;
